import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiOutlineX } from "react-icons/hi";
import italianBg from "../../common/images/italian-bg.png";
import airportSolution from "../../common/images/airport-solution.png";
import compareBg from "../../common/images/compare-bg.png";
import smartParking from "../../common/images/smart-bg.png";

import aygoBG from "../../common/images/aygo-bg.png";
import chikitosBG from "../../common/images/chikitos.bg.png";
import Crm from "../../common/images/crm-mocks.png";
import customOne from "../../common/images/custom-s-1.png";
import customTwo from "../../common/images/custom-s-2.png";
import customThree from "../../common/images/custom-s-3.png";
import binaryParkBG from "../../common/images/binarypark-bg.png";
import andOne from "../../common/images/mock-a-1.png"
import andTwo from "../../common/images/mock-a-2.png"
import andThree from "../../common/images/mock-a-3.png"
import andFour from "../../common/images/mock-a-4.png"


const featuredData = {
  3: {
    title: "Web Development",
    projects: [
      {
        img: italianBg,
        name: "Italian Pizza UK",
        link: "https://www.italianpizzas.co.uk/",
      },
      {
        img: airportSolution,
        name: "Airport Parking Solution",
        link: "https://www.airportparkingsolutions.com",
      },
      {
        img: aygoBG,
        name: "Aygo Airport Parking",
        link: "https://www.aygoparking.co.uk/",
      },
      {
        img: chikitosBG,
        name: "Chikitos Peri Peri UK",
        link: "https://www.chikitosperiperi.co.uk/",
      },
      {
        img: compareBg,
        name: "Compare Airport Parking Deals",
        link: "https://www.compareairportparkingdeals.co.uk",
      },
      {
        img: smartParking,
        name: "Smart Parking Deals",
        link: "https://www.smartparkingdeals.co.uk/",
      },
    ],
  },
  2: {
    title: "UI/UX Design",
    projects: [
      {
        img: italianBg,
        name: "Italian Pizza UK",
        link: "https://www.italianpizzas.co.uk/",
      },
      {
        img: airportSolution,
        name: "Airport Parking Solution",
        link: "https://www.airportparkingsolutions.com",
      },
      {
        img: aygoBG,
        name: "Aygo Airport Parking",
        link: "https://www.aygoparking.co.uk/",
      },
      {
        img: chikitosBG,
        name: "Chikitos Peri Peri UK",
        link: "https://www.chikitosperiperi.co.uk/",
      },
      {
        img: compareBg,
        name: "Compare Airport Parking Deals",
        link: "https://www.compareairportparkingdeals.co.uk",
      },
      {
        img: smartParking,
        name: "Smart Parking Deals",
        link: "https://www.smartparkingdeals.co.uk/",
      },
    ],
  },
  1: {
    title: "Crm Project ",
    projects: [
      {
        img: Crm,
        name: "Customer Relationship Management (CRM) ",
        // link: "https://admin.compareairportparkingdeals.co.uk/admin/dashboard",
      },
    ],
  },
  5: {
    title: "Custom Development ",
    projects: [
      {
        img: customThree,
        name: "COMPARE AIRPORT PARKING DEALS DASHBOARD",
        // link: "https://admin.compareairportparkingdeals.co.uk/admin/dashboard",
      },
      {
        img: customTwo,
        name: "BINARY PARKING MANAGEMENT",
        // link: "https://admin.compareairportparkingdeals.co.uk/admin/dashboard",
      },
      {
        img:  customOne,
        name: "ITALIAN PIZZA DASHBOARD",
        // link: "https://admin.compareairportparkingdeals.co.uk/admin/dashboard",
      },
      {
        img: binaryParkBG,
        name: "BINARY PARK ME",
        // link: "https://client.binaryparkme.com/",
      },
    ],
  },
  4: {
    title: "Android Development ",
    projects: [
      {
        img: andOne,
        name: " RECOVERY APP",
        link: "https://play.google.com/store/apps/details?id=com.sapphire.data.recovery.photo.video.deleted",
      },
      {
        img: andTwo,
        name: "PHOTO LAB APP",
        link: "https://play.google.com/store/apps/details?id=com.photolab.coloreffects.photoart",
      },
      {
        img: andThree,
        name: " ISLAM APP",
        link: "https://play.google.com/store/apps/details?id=com.islam.muslim.life360.quran",
      },
      {
        img: andFour,
        name: " Smart Switch App",
        link: "https://play.google.com/store/apps/details?id=com.SmartSwitch.Shareit.TransferFiles",
      },
    ],
  },
};

export default function Featured({ selected }) {
  const { title, projects } = featuredData[selected] || {};
  const [visibleCount, setVisibleCount] = useState(4);
  const isExpanded = visibleCount >= projects?.length;

  return (
    <div className="relative flex flex-col items-center small:px-10 px-5 small:py-10 py-5">
      {/* Animation wrapper */}
      <AnimatePresence mode="wait">
        {selected && (
          <motion.div
            key={selected} // Ensures animation runs on change
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
            className="w-full flex flex-col items-center"
          >
            {/* <h2 className="md:text-4xl small:text-3xl text-2xl font-bold mb-6 text-secondary">
              {title}
            </h2> */}
            <div
              className={`grid ${
                projects?.length === 1
                  ? "grid-cols-1"
                  : "grid-cols-1 md:grid-cols-2"
              } gap-6 max-w-6xl w-full`}
            >
              {projects?.slice(0, visibleCount).map((project, index) => (
                <a
                  key={index}
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <motion.div
                    className="relative bg-gray-900 border-2 border-white rounded-3xl  overflow-hidden shadow-lg"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeOut",
                      delay: index * 0.1,
                    }}
                  >
                    <img
                      src={project.img}
                      alt={project.name}
                      className="w-[100%] small:h-[400px] h-[200px] object-cover bg-center opacity-80"
                    />
                    <div className="absolute bottom-2 left-2">
                      <h3 className="text-white text-lg md:text-xl font-bold  bg-opacity-70 px-4 py-2 rounded">
                        {project.name}
                      </h3>
                    </div>
                  </motion.div>
                </a>
              ))}
            </div>

            {projects?.length > 4 && (
              <button
                onClick={() =>
                  setVisibleCount(isExpanded ? 4 : projects.length)
                }
                className="mt-6 bg-black text-white px-6 py-3 rounded-lg hover:bg-opacity-80 transition"
              >
                {isExpanded ? "Show Less" : "Load More"}
              </button>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
